import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import logoCenec from "../assets/cenec_2.svg";
import logoChorotega from "../assets/chorotega_2.svg";
import { ADVICE, TYPE_OF_ORGANIZATION, YESNO, BUSINESS_CATEGORY } from "../utils/constants";
import { XLg } from "react-bootstrap-icons";
import { useFormContext } from "react-hook-form";

export const SlideTwo = () => {
  const { register, getValues, setValue, formState: { errors }, } = useFormContext();
  const [showDestinationInput, setShowDestinationInput] = useState(false);
  const [showAdviceInput, setShowAdviceInput] = useState(false);

  const initialTags = (() => {
    const mainProducts = getValues("main_products");
    try {
      return mainProducts ? JSON.parse(mainProducts) : [];
    } catch (error) {
      return [];
    }
  })();

  const [tags, setTags] = useState(initialTags);

  const initialAdvice = (() => {
    const advice = getValues("advice");
    try {
      return advice ? JSON.parse(advice) : [];
    } catch (error) {
      return [];
    }
  })();

  const [selectedAdvice, setSelectedAdvice] = useState(initialAdvice);

  useEffect(() => {
    // Restaura el estado de visibilidad para "¿Exporta sus productos?" y "Asesoria"
    setShowDestinationInput(getValues("exports_products") === "Y");
    setShowAdviceInput(initialAdvice.includes("OTR"));
  }, [getValues, initialAdvice]);

  useEffect(() => {
    // Sincroniza `selectedAdvice` con `advice` en JSON
    setValue("advice", JSON.stringify(selectedAdvice));
  }, [selectedAdvice, setValue]);


  useEffect(() => {
    // Sincroniza tags con main_products en el registro de react-hook-form
    setValue("main_products", JSON.stringify(tags));
  }, [tags, setValue]);

  const handleExportChange = (e) => {
    const isExporting = e.target.value === "Y";
    setShowDestinationInput(isExporting);
    setValue("exports_products", e.target.value); // Guarda el valor en el formulario

    if (!isExporting) {
      setValue("where_export", ""); // Limpia el campo de destino si selecciona "No"
    }
  }

  const handleAdviceChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      // Agregar la opción seleccionada
      setSelectedAdvice([...selectedAdvice, value]);
    } else {
      // Remover la opción desmarcada
      setSelectedAdvice(selectedAdvice.filter((item) => item !== value));
    }

    // Verifica si se selecciona "OTR" para mostrar el campo adicional
    const isOtherSelected = value === "OTR" && checked;
    setShowAdviceInput(isOtherSelected);

    if (!isOtherSelected) {
      setValue("advice_explain", ""); // Limpia el campo de destino si selecciona "No"
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && e.target.value.trim() !== "") {
      e.preventDefault();
      const newTag = e.target.value.trim();
      setTags([...tags, newTag]);
      setValue("main_products", [...tags, newTag]);
      e.target.value = "";
    }
  };

  const removeTag = (index) => {
    const newTags = tags.filter((_, i) => i !== index);
    setTags(newTags);
    setValue("main_products", newTags);
  };

  return (
    <Container className="" style={{ maxWidth: "1200px" }}>
      <div className="d-flex justify-content-center mb-3 ms-2 me-2">
        <Card className="card-custom-style">
          <Card.Header className="white-bg-color">
            <Row className="justify-content-center">
              <Col md={10}>
                <Row className="justify-content-center cenec-bg-color-v2 mx-1 p-3 rounded-1 mb-3 mt-3">
                  <Col
                    xl={5}
                    md={5}
                    sm={5}
                    xs={12}
                    className="order-last order-sm-first order-md-first"
                  >
                    <div className="d-flex justify-content-center align-items-center">
                      <img
                        src={logoCenec}
                        alt="Logo CENEC"
                        className="img-cenec"
                      />
                    </div>
                  </Col>
                  <Col
                    xl={2}
                    md={2}
                    sm={2}
                    className="d-none d-sm-block text-center"
                  >
                    <div className="vl"></div>
                  </Col>
                  <Col xs={12} className="d-block d-sm-none">
                    <div className="hl"></div>
                  </Col>
                  <Col
                    xl={5}
                    md={5}
                    sm={5}
                    xs={12}
                    className="order-first order-sm-last order-md-last"
                  >
                    <div className="d-flex justify-content-center align-items-center">
                      <img
                        src={logoChorotega}
                        alt="Logo Cooperativa Chorotega"
                        className="img-owner"
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <Form>
              <Row className="justify-content-center">
                <Col md="10" className="mt-3 mb-2">
                  <h2 className="fs-5">
                    Formulario para registro de clientes CENEC
                  </h2>
                </Col>
                <div className="w-100"></div>
                <Col md="10" className="mt-3 mb-2">
                  <h2 className="fs-5">
                    II. Información de la empresa o emprendimiento
                  </h2>
                </Col>
                <div className="w-100"></div>

                <Col md="10" sm="12" xs="12" className=" mb-3">
                  <div className="form-floating">
                    <Form.Control
                      type="text"
                      id="idBusiness_name"
                      placeholder=""
                      {...register("business_name", {
                        required: "Nombre negocio es requerido",
                      })}
                    />
                    {errors.business_name && (
                      <p className="text-danger">
                        {errors.business_name.message}
                      </p>
                    )}
                    <label htmlFor="idBusiness_name">Nombre del negocio</label>
                  </div>
                </Col>
                <Col md="10" sm="12" xs="12" className=" mb-3">
                  <div className="form-floating">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      id="idBusiness_address"
                      placeholder=" "
                      style={{ height: "auto" }}
                      {...register("business_address", {
                        required: "La dirección es requerida",
                      })}
                    />
                    {errors.business_address && (
                      <p className="text-danger">
                        {errors.business_address.message}
                      </p>
                    )}
                    <label htmlFor="idBusiness_address">Dirección</label>
                  </div>
                </Col>

                <Col md="10" sm="6" xs="12" className="mb-3">
                  <div className="form-floating">
                    <select
                      className="form-select"
                      id="idBusinessCategory"
                      aria-label="Selecciona Departamento"
                      {...register("business_category", {
                        required: "Rubro de la empresa es requerida",
                      })}
                    >
                      <option value="">Seleccione Rubro</option>
                      {BUSINESS_CATEGORY.map((item) => (
                        <option key={item.value} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                    {errors.business_category && (
                      <p className="text-danger">{errors.business_category.message}</p>
                    )}
                    <label htmlFor="idBusinessCategory">Rubro de la empresa</label>
                  </div>
                </Col>

                <Col md="10" sm="12" xs="12" className="mb-3">
                  <Form.Label>Tipo de organización</Form.Label>
                  <div className="d-flex">
                    {TYPE_OF_ORGANIZATION.map((option) => (
                      <Form.Check
                        key={option.value}
                        type="radio"
                        id={`type_of_organization-${option.value}`}
                        label={option.label}
                        value={option.value}
                        name="type_of_organization"
                        className="me-3"
                        {...register("type_of_organization", {
                          required: "El tipo de organización es requerido",
                        })}
                      />
                    ))}
                  </div>
                  {errors.type_of_organization && (
                    <p className="text-danger">
                      {errors.type_of_organization.message}
                    </p>
                  )}
                </Col>
                <Col md="10" sm="12" xs="12" className=" mb-3">
                  <Form.Label>¿Exporta sus productos?</Form.Label>
                  <div className="d-flex">
                    {YESNO.map((option) => (
                      <Form.Check
                        key={option.value}
                        type="radio"
                        id={`exports_products-${option.value}`}
                        label={option.label}
                        value={option.value}
                        name="exports_products"
                        className="me-3"
                        {...register("exports_products", {
                          required: "Exporta productos es requerido",
                        })}
                        onChange={handleExportChange}
                      />
                    ))}
                  </div>
                  {errors.exports_products && (
                    <p className="text-danger">
                      {errors.exports_products.message}
                    </p>
                  )}
                </Col>

                {showDestinationInput && (
                  <Col md="10" sm="12" xs="12" className="mb-3">
                    <Form.Label>¿A dónde envía el producto?</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Ingrese el destino de exportación"
                      {...register("where_export", {
                        required:
                          "El destino de exportación es requerido cuando selecciona 'Sí'",
                      })}
                    />
                    {errors.where_export && (
                      <p className="text-danger">
                        {errors.where_export.message}
                      </p>
                    )}
                  </Col>
                )}

                <Col md="10" sm="12" xs="12" className=" mb-3">
                  <Form.Label>Enliste sus principales productos</Form.Label>
                  <Form.Control
                    type="text"

                    onKeyDown={handleKeyDown}
                    placeholder="Escribe y presiona Enter"
                  />

                  <input
                    type="hidden"
                    className="form-control"
                    value={JSON.stringify(tags)} // Convertimos tags a JSON para enviarlo como string
                    {...register("main_products", {
                      required: "Productos principales es requerida",
                    })}
                  />
                  <div className="d-flex flex-wrap mt-3">
                    {tags.map((tag, index) => (
                      <div
                        key={index}
                        className="d-inline-flex align-items-center me-2 mb-2 p-1 border rounded bg-primary text-white"
                      >
                        {tag}
                        <Button
                          variant="link"
                          size="sm"
                          className="ms-2 text-white"
                          onClick={() => removeTag(index)}
                        >
                          <XLg />
                        </Button>
                      </div>
                    ))}
                  </div>
                </Col>

                <Col md="10" sm="12" xs="12" className=" mb-3">
                  <Form.Label>Selecciona las áreas en las que te gustaría recibir capacitación</Form.Label>
                  <div className="">
                    {ADVICE.map((option) => (
                      <Form.Check
                        key={option.value}
                        type="checkbox"
                        id={`advice-${option.value}`}
                        label={option.label}
                        value={option.value}
                        name="advice"
                        className="me-3"
                        checked={selectedAdvice.includes(option.value)}
                        onChange={handleAdviceChange}
                      />
                    ))}
                  </div>
                  {errors.advice && (
                    <p className="text-danger">{errors.advice.message}</p>
                  )}
                </Col>

                <input
                  type="hidden"
                  value={JSON.stringify(selectedAdvice)} // Convierte selectedAdvice a JSON
                  {...register("advice", {
                    required: "Asesoría es requerida",
                  })}
                />

                {showAdviceInput && (
                  <Col md="10" sm="12" xs="12" className="mb-3">
                    <Form.Label>Explique</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Ingrese otra asesoria"
                      {...register("advice_explain", {
                        required:
                          "La asesoria es requerida cuando selecciona 'Otros'",
                      })}
                    />
                    {errors.advice_explain && (
                      <p className="text-danger">
                        {errors.advice_explain.message}
                      </p>
                    )}
                  </Col>
                )}
              </Row>
            </Form>
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};
